import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material';
import {
  createAdviserViewRoute,
  createInvestorViewRoute,
  createInvestmentViewLink,
} from 'adminConstants/routes';

interface UserLinkProps {
  to: string;
  name: string;
  newTab?: boolean;
}

interface InvestorLinkProps {
  investorId: string;
  investorName: string;
}

interface AdviserLinkProps {
  adviserId: string;
  adviserName: string;
}

interface SubscriptionAsInvestorLinkProps {
  subscriptionId: string;
  investorFullName: string;
}

const StyledLink = styled(Link)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.text.green,
}));

const UserLink: React.FC<UserLinkProps> = ({ to, name, newTab }) => (
  <StyledLink to={to} target={newTab ? '_blank' : undefined}>
    {name}
  </StyledLink>
);

export const InvestorLink: React.FC<InvestorLinkProps> = ({
  investorId,
  investorName,
}) => <UserLink to={createInvestorViewRoute(investorId)} name={investorName} />;

export const AdviserLink: React.FC<AdviserLinkProps> = ({
  adviserId,
  adviserName,
}) => <UserLink to={createAdviserViewRoute(adviserId)} name={adviserName} />;

export const SubscriptionAsInvestorLink: React.FC<
  SubscriptionAsInvestorLinkProps
> = ({ subscriptionId, investorFullName }) => (
  <UserLink
    newTab
    to={createInvestmentViewLink(subscriptionId)}
    name={investorFullName}
  />
);

export default UserLink;
